import React, { memo } from 'react';
import { UploadCloud } from 'lucide-react';

/**
 * File upload button component
 * Triggers hidden file input when clicked
 */
const FileUploadButton = memo(({ 
  fileInputRef, 
  handleFileUpload, 
  isEventConnected, 
  agentStatus,
  isSandboxReady,
  readOnly = false 
}) => {
  const isDisabled = readOnly || !isEventConnected || agentStatus === 'generating' || !isSandboxReady;

  return (
    <>
      <button
        type="button"
        onClick={() => fileInputRef.current?.click()}
        className={`p-2 rounded-lg hover:bg-slate-200 dark:hover:bg-neutral-700 flex items-center transition-colors min-w-0 ${
          isDisabled
            ? 'text-neutral-400 cursor-not-allowed'
            : 'text-neutral-600 dark:text-neutral-400'
        }`}
        title="Thread Images"
        disabled={isDisabled}
        data-tour="file-upload"
      >
        <UploadCloud size={18} />
      </button>
      <input 
        type="file" 
        ref={fileInputRef} 
        className="hidden" 
        multiple 
        accept="image/*"
        onChange={handleFileUpload} 
      />
    </>
  );
});

FileUploadButton.displayName = 'FileUploadButton';

export default FileUploadButton;